'use strict';

var defineProperty = require('../../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var makeStyles = require('../../../Styles/makeStyles.js');
var classNames = require('classnames');
var AppBar$1 = require('../../../../node_modules/@material-ui/core/esm/AppBar/AppBar.js');
var Toolbar = require('../../../../node_modules/@material-ui/core/esm/Toolbar/Toolbar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles = makeStyles["default"](function (theme) {
  return {
    root: {
      zIndex: 1101,
      height: 72,
      borderBottom: 'solid 1px #e0e0e0',
      color: '#212121' // theme.palette.text.main Need to change this to pull from Theme when Theme is worked out in housecall-web

    },
    toolbarGutters: {
      paddingLeft: 24,
      paddingRight: 16
    }
  };
});
var AppBarDeprecated = React__default["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      toolbarProps = _ref.toolbarProps,
      restOfProps = objectWithoutProperties(_ref, ["children", "toolbarProps"]);

  var _useStyles = useStyles(),
      root = _useStyles.root,
      toolbarGutters = _useStyles.toolbarGutters;

  var _ref2 = toolbarProps || {},
      _ref2$classes = _ref2.classes,
      toolbarClasses = _ref2$classes === void 0 ? {} : _ref2$classes;

  toolbarClasses.gutters = classNames__default["default"](toolbarGutters, toolbarClasses.gutters);
  console.warn('This version of AppBar is deprecated. Use AppBar and Toolbar V2 separately.');
  return React__default["default"].createElement(AppBar$1["default"], _objectSpread({
    className: root,
    ref: ref
  }, restOfProps), React__default["default"].createElement(Toolbar["default"], _objectSpread({
    classes: toolbarClasses
  }, toolbarProps), children));
});
var AppBar = React__default["default"].forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      toolbarProps = _ref3.toolbarProps,
      version = _ref3.version,
      restOfProps = objectWithoutProperties(_ref3, ["children", "toolbarProps", "version"]);

  if (version === 'v2') {
    return React__default["default"].createElement(AppBar$1["default"], _objectSpread({
      ref: ref
    }, restOfProps), children);
  } else {
    return React__default["default"].createElement(AppBarDeprecated, _objectSpread({
      children: children,
      toolbarProps: toolbarProps,
      ref: ref
    }, restOfProps));
  }
});
AppBar.defaultProps = {
  color: 'primary',
  elevation: 0
};

module.exports = AppBar;
